export default {
  'CONTACT.REPORT.SUB.TITLE': '联系人报表',
  'CONTACT.REPORT.FILTER.MODIFIED.DESC': '筛选项数据被修改，请确认',
  'CONTACT.REPORT.FILTERS': '筛选器',
  'CONTACT.REPORT.FILTERS.BLOCK.L': '排除',
  'CONTACT.REPORT.FILTERS.BLOCK.C': '拒绝列表',
  'CONTACT.REPORT.FILTERS.BLOCK.R':
    '和<a href="{url}" target="_blank" style="text-decoration: none;">SLHP</a>',
  'CONTACT.REPORT.FILTERS.MY': '我的筛选',
  'CONTACT.REPORT.FILTERS.MY.EDIT': '编辑筛选器',
  'CONTACT.REPORT.FILTERS.MY.NO.DATA': '暂无筛选器',
  'CONTACT.REPORT.FILTERS.MY.DEL.TITLE': '确定删除筛选器？',
  'CONTACT.REPORT.FILTERS.MY.DEL.DESC':
    "删除 <b class='color-333'>{name}</b> 后，筛选器信息不可恢复。",
  'CONTACT.REPORT.FILTERS.DATE.PRESETS': '近{num}天',
  'CONTACT.REPORT.FILTERS.DATE.PRESETS.ALL': '全部时间',
  'CONTACT.REPORT.FILTERS.MY.NO.SOURCE': '暂无来源',
  'CONTACT.REPORT.FILTERS.PREFERENCE': '偏好',
  'CONTACT.REPORT.FILTERS.MY.NO.PREFERENCE': '暂无偏好',
  'CONTACT.REPORT.FILTERS.PREFERENCE.EMPTY.TEXT': '暂无偏好，请创建',
  'CONTACT.REPORT.FILTERS.PREFERENCE.CREATE': '创建偏好',
  'CONTACT.REPORT.FILTERS.MY.NO.RATING': '暂无参与度',
  'CONTACT.REPORT.FILTERS.REGION': '区域',
  'CONTACT.REPORT.FILTERS.MY.NO.REGION': '暂无区域',
  'CONTACT.REPORT.FILTERS.REGION.CUSTOM.AREA.GROUP.TITLE': '大区',
  'CONTACT.REPORT.FILTERS.REGION.GROUP.TITLE': '区域',
  'CONTACT.REPORT.FILTERS.REGION.GO.L':
    '可新建大区，移动Others内区域到新建大区中。<br/>快使用',
  'CONTACT.REPORT.FILTERS.REGION.GO.C': '区域管理',
  'CONTACT.REPORT.FILTERS.REGION.GO.R': '更新区域的大区划分吧',
  'CONTACT.REPORT.FILTERS.LANG': '语言',
  'CONTACT.REPORT.FILTERS.MY.NO.LANG': '暂无语言',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE': '字段',
  'CONTACT.REPORT.FILTERS.MY.NO.ATTRIBUTE': '暂无字段',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE.CHILDREN.ALL.OR.AND.DESC':
    '具备选择的任意一个选项即可',
  'CONTACT.REPORT.FILTERS.MY.NO.TAG': '暂无标签',
  'CONTACT.REPORT.FILTERS.TAG.EMPTY.TEXT': '暂无标签，请创建',
  'CONTACT.REPORT.FILTERS.MY.NO.SEGMENT': '暂无分层',
  'CONTACT.REPORT.FILTERS.SEGMENT.EMPTY.TEXT': '暂无分层，请创建',
  'CONTACT.REPORT.FILTERS.SAVE': '保存到我的筛选',
  'CONTACT.REPORT.FILTERS.SAVE.TIPS': '我的筛选已达最大数量',
  'CONTACT.REPORT.FILTERS.NAME': '筛选器名称',
  'CONTACT.REPORT.FILTERS.NAME.LIMIT': '请输入我的筛选名称，上限{num}字符',
  'CONTACT.REPORT.FILTERS.SAVE.SUCCESS': '保存成功',
  'CONTACT.REPORT.FILTERS.PREFERENCE.ALL.TIP':
    '系统内联系人偏好，具备此处选择的全部偏好',
  'CONTACT.REPORT.FILTERS.PREFERENCE.ANY.TIP':
    '系统内联系人的偏好，具备此处选择的任意一个偏好即可',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE.ALL.TIP':
    '系统内联系人字段，具备此处选择的全部字段',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE.ANY.TIP':
    '系统内联系人的字段，具备此处选择的任意一个字段即可',
  'CONTACT.REPORT.KEY.METRICS': '关键指标模块',
  'CONTACT.REPORT.CONTACTS': '新增联系人',
  'CONTACT.REPORT.CONTACTS.LOADING': '联系人数量加载中...',
  'CONTACT.REPORT.SUBSCRIBERS': '新增已定阅联系人',
  'CONTACT.REPORT.SUBSCRIBERS.RATE': '订阅率',
  'CONTACT.REPORT.SUBSCRIBERS.LOADING': '已订阅联系人加载中...',
  'CONTACT.REPORT.ENGAGEMENT.LEVEL.AVG.DESC': '平均分级',
  'CONTACT.REPORT.CONTACTS.TREND': '联系人变化趋势',
  'CONTACT.REPORT.ACCUMULATED': '累计',
  'CONTACT.REPORT.SUBSCRIBED': '已订阅',
  'CONTACT.REPORT.UNSUBSCRIBE': '未订阅',
  'CONTACT.REPORT.NON.SUBSCRIBE': '未知',
  'CONTACT.REPORT.PENDING': '待定',
  'CONTACT.REPORT.CONTACTS.DIST': '联系人分布',
  'CONTACT.REPORT.PREFERENCE': '偏好分布',
  'CONTACT.REPORT.SOURCES': '来源分布',
  'CONTACT.REPORT.SOURCES.SWITCH': '只统计联系人首次导入的来源',
  'CONTACT.REPORT.SUBSCRIPTION': '订阅状态分布',
  'CONTACT.REPORT.LANGUAGES': '语言分布',
  'CONTACT.REPORT.LOCATIONS': '地区分布',
  'CONTACT.REPORT.LOCATIONS.ZONES.TITLE': '大区',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.L': '可在',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.C': '区域管理',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.R': '中更新区域的大区划分',
  'CONTACT.REPORT.NO.DATA': '暂无数据',
  'CONTACT.REPORT.LOCATIONS.ZONES.TITLE': '大区',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.L': '可在',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.C': '区域管理',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.R': '中更新区域的大区划分',
  'CONTACT.REPORT.PREFERENCE.MORE': '了解更多',
  'CONTACT.REPORT.ECHARTS.MAP.HEIGHT': '高',
  'CONTACT.REPORT.ECHARTS.MAP.LOW': '低',
  'CONTACT.REPORT.SUBSCRIBED.CONTACTS': '已订阅联系人',
  'CONTACT.REPORT.UN.SUBSCRIBED.CONTACTS': '未订阅联系人',
};
